import { AuthoriseCoinJarWalletRequestBody } from "@syla/shared/types/requests/AuthoriseCoinJarWalletRequest";
import axios from "axios";
import { queryClient } from "../transactionsStore";
import { WALLETS_QUERY_CACHE_KEY } from "./wallet";

export type AuthoriseCoinJarWalletRequestProps = {
  walletId: string;
  accessGrantCode: string;
  redirectUrl: string;
};
export const authoriseCoinJarWallet = async (
  props: AuthoriseCoinJarWalletRequestProps
): Promise<void> => {
  try {
    await authoriseCoinJarWalletRequest(props);
  } finally {
    queryClient.invalidateQueries(WALLETS_QUERY_CACHE_KEY);
  }
};

const authoriseCoinJarWalletRequest = async ({
  walletId,
  redirectUrl,
  accessGrantCode,
}: AuthoriseCoinJarWalletRequestProps) => {
  const body: AuthoriseCoinJarWalletRequestBody = {
    accessGrantCode,
    walletId,
    redirectUrl,
  };
  return axios.post(`/wallets/authorise-coinjar-wallet`, body);
};
